<!--polygon-->
<div *ngIf="isShowMap" [ngClass]="customClass">
  <form-textarea
    class="tw-w-full"
    label="common.desiredPolygon"
    [(value)]="polygon"
    (valueChange)="emitPolygon()"
    [control]="form?.get('polygon')"
    [rows]="5"
    [placeholder]="polygonSample"
  >
  </form-textarea>
</div>

<!-- <p
  class="tw-flex alert alert-warning tw-justify-start tw-items-center tw-text-gray-700 tw-font-medium"
>
  ●
  {{ "messages.reversePolygonAlert" | translate }}
</p> -->

<!-- reverse polygon-->
<div class="tw-w-full tw-mt-3 tw-mb-5">
  <div class="tw-flex tw-justify-between tw-items-center">
    <div class="checkbox-section">
      <mat-slide-toggle
        formControlName="isReverse"
        (change)="reversePolygon()"
        [color]="'accent'"
      >
        {{ "common.reversePolygon" | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</div>
